import { useContext } from 'react';

import { trackGAEvent } from '../../utils/trackEvent';
import { GTMContext } from '../context/GTMContext';

import type { PageType } from '../enums';

export const useGTM = (pageType: PageType) => {
  const gtm = useContext(GTMContext);

  if (!gtm) {
    throw new Error('useGTM must be used within GTMProvider');
  }

  const trackEvent = (eventName: string, additionalParams?: Record<string, string | boolean | number>) => {
    const storedParams = gtm.getParams(pageType);

    const mergedParams = {
      ...storedParams,
      ...additionalParams,
      pageType,
    };

    trackGAEvent(eventName, mergedParams);
  };

  return { trackEvent };
};
